module.exports = __webpack_public_path__ + "img/TNT.e6779572.png";